import { UPDATE_ALGOS_LIVE_STATS } from '../../constants/ActionTypes';

const algosListStats = (
  state = {
    positions: [],
    latestMTMGroupPnl: undefined,
    totalPnl: undefined,
    updatedAt: null,
  },
  action
) => {
  switch (action.type) {
    case UPDATE_ALGOS_LIVE_STATS:
      return {
        ...state,
        ...action.data,
        updatedAt: Date.now(),
      };
    default:
      return state;
  }
};

export default algosListStats;
